var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHomeFull = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/home-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0422 6.82L14.2822 2.79C12.7122 1.69 10.3022 1.75 8.79219 2.92L3.78219 6.83C2.78219 7.61 1.99219 9.21 1.99219 10.47V17.37C1.99219 19.92 4.06219 22 6.61219 22H17.3922C19.9422 22 22.0122 19.93 22.0122 17.38V10.6C22.0122 9.25 21.1422 7.59 20.0422 6.82ZM12.7522 18C12.7522 18.41 12.4122 18.75 12.0022 18.75C11.5922 18.75 11.2522 18.41 11.2522 18V15C11.2522 14.59 11.5922 14.25 12.0022 14.25C12.4122 14.25 12.7522 14.59 12.7522 15V18Z",
    fill: "currentColor"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHomeFull, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/home-full.f0692b38.svg";
export { ForwardRef as ReactComponent };